
export default function removeGlobalFormError(inputField)
{
  const form = inputField.closest('form')
  const formError = form.querySelector('.form-results-error')

  formError.classList.add('d-none')
}
